module.exports = __webpack_public_path__ + "img/trains3.6ddf750b.svg";